import { INLINE_TARGET_ATTR, INLINE_TARGET_ATTR_RNG, INLINE_TARGET_FORMAT } from '../constants/inlineTarget';
import { isWhitespace } from '../utils';
import { BOGUS_DATA_ATTR } from './dom';

// Remove the inline target if it's still present in the DOM
export function removeInlineTarget(editor, target, restoreSelection) {
  const body = editor.getBody();
  const shouldRestoreSelection = editor.hasFocus() || restoreSelection;
  if (target && target.hasAttribute(INLINE_TARGET_ATTR) && body && body.contains(target)) {
    let bookmark;
    if (shouldRestoreSelection) {
      bookmark = editor.selection.getBookmark();
    }
    if (target.hasAttribute(INLINE_TARGET_ATTR_RNG)) {
      editor.selection.select(target);
      editor.formatter.remove(INLINE_TARGET_FORMAT);
    } else {
      editor.dom.remove(target);
    }
    if (shouldRestoreSelection && bookmark) {
      editor.selection.moveToBookmark(bookmark);
    }
  }
}

// Create & return an inline target given the current
// collapsed or range selection
export function createInlineTarget(editor) {
  let inlineTarget;
  if (!editor.selection) return null;
  const selectedNode = editor.selection.getNode();
  const selectionContent = editor.selection.getContent({
    format: 'text'
  });
  const rng = editor.selection.getRng();
  const selectionIsInlineTarget = selectedNode.nodeName === 'SPAN' && selectedNode.hasAttribute(INLINE_TARGET_ATTR);
  const selectionIsInlineTargetRng = selectionIsInlineTarget && selectedNode.hasAttribute(INLINE_TARGET_ATTR_RNG);
  const selectionIsBogusTextNode = selectedNode.nodeName === '#text' && isWhitespace(selectionContent) && selectionContent.length < 1;
  if (editor.selection.isCollapsed() || selectionIsBogusTextNode || selectionIsInlineTarget && !selectionIsInlineTargetRng) {
    // Create a collapsed inline target
    inlineTarget = editor.dom.create('span', {
      [INLINE_TARGET_ATTR]: 'true',
      [BOGUS_DATA_ATTR]: '1'
    });
    rng.insertNode(inlineTarget);
  } else {
    if (selectionIsInlineTargetRng && selectedNode.parentNode) {
      inlineTarget = selectedNode.cloneNode(true);
      selectedNode.parentNode.replaceChild(inlineTarget, selectedNode);
    } else {
      // Apply the inline target format only to the first node of the range
      if (rng.startContainer !== rng.endContainer) {
        rng.setEndAfter(rng.startContainer);
        editor.selection.setRng(rng);
      }
      editor.formatter.apply(INLINE_TARGET_FORMAT);
      inlineTarget = editor.dom.getParent(editor.selection.getRng().startContainer, `span[${INLINE_TARGET_ATTR_RNG}]`);
    }
  }
  return inlineTarget;
}